import { observable, action, makeObservable } from 'mobx';

class VehicleStore {
  constructor(appStore) {
    this.appStore = appStore;
    makeObservable(this, {
      vehicleSelected: observable,
      getPersonalVehicles: action,
      getCompanyVehicles: action,
    });
  }

  vehicleSelected = null;

  getPersonalVehicles(driverId, query, cb) {
    let params = new URLSearchParams();

    Object.keys(query).map((t) => {
      params.append(t, query[t]);
    });

    return this.appStore.api.get(`/vehicles/driver/${driverId}?${params}`);
  }

  getCompanyVehicles(courierId, query, cb) {
    let params = new URLSearchParams();

    Object.keys(query).map((t) => {
      params.append(t, query[t]);
    });

    return this.appStore.api.get(`/vehicles/courier/${courierId}?${params}`);
  }

  assignVehicle = (vehicleId, driverId) => this.appStore.api.put(`/vehicles/${vehicleId}/assign/${driverId}`);

  unassignVehicle = (vehicleId, driverId) => this.appStore.api.delete(`/vehicles/${vehicleId}/unassign/${driverId}`);
}

export default VehicleStore;
